export const investments = {


}
